import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["rendererSettings"],
  _excluded2 = ["id"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var n = 0, F = function F() {}; return { s: F, n: function (_n4) { function n() { return _n4.apply(this, arguments); } n.toString = function () { return _n4.toString(); }; return n; }(function () { return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] }; }), e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { a as a$1 } from './chunk-74T7T5LL.js';
import { a as a$3 } from './chunk-GSRQSB3U.js';
import { a } from './chunk-BHJSY5WG.js';
import { p, a as a$2, j as j$1, i, h, m, n, l } from './chunk-DCAKKOYV.js';
var U = {
  name: "@dotlottie/common",
  version: "0.7.11",
  type: "module",
  description: "",
  author: "Afsal <afsal@lottiefiles.com>, Sam Osborne <sam@lottiefiles.com>",
  license: "MIT",
  engines: {
    node: ">18.0.0"
  },
  module: "dist/index.js",
  main: "dist/index.js",
  types: "dist/index.d.ts",
  files: ["dist"],
  keywords: [],
  scripts: {
    build: "tsup",
    dev: "tsup --watch",
    lint: "eslint .",
    "type-check": "tsc --noEmit"
  },
  dependencies: {
    "@dotlottie/dotlottie-js": "^0.7.0",
    "@preact/signals-core": "^1.2.3",
    howler: "^2.2.3",
    "lottie-web": "^5.12.2",
    xstate: "^4.38.1"
  },
  devDependencies: {
    "@lottiefiles/lottie-types": "^1.2.0",
    "@types/howler": "^2.2.8",
    tsup: "^7.2.0",
    typescript: "^4.7.4"
  },
  publishConfig: {
    access: "public"
  }
};
var W = function (l) {
    return l.Complete = "complete", l.DataFail = "data_fail", l.DataReady = "data_ready", l.Error = "error", l.Frame = "frame", l.Freeze = "freeze", l.LoopComplete = "loopComplete", l.Pause = "pause", l.Play = "play", l.Ready = "ready", l.Stop = "stop", l.VisibilityChange = "visibilityChange", l;
  }(W || {}),
  K = function (d) {
    return d.Completed = "completed", d.Error = "error", d.Fetching = "fetching", d.Frozen = "frozen", d.Initial = "initial", d.Loading = "loading", d.Paused = "paused", d.Playing = "playing", d.Ready = "ready", d.Stopped = "stopped", d;
  }(K || {}),
  G = function (e) {
    return e.Bounce = "bounce", e.Normal = "normal", e;
  }(G || {}),
  u = {
    autoplay: !1,
    direction: 1,
    hover: !1,
    intermission: 0,
    loop: !1,
    playMode: "normal",
    speed: 1,
    defaultTheme: ""
  },
  Q = {
    activeStateId: "",
    autoplay: !1,
    currentState: "initial",
    frame: 0,
    seeker: 0,
    direction: 1,
    hover: !1,
    loop: !1,
    playMode: "normal",
    speed: 1,
    background: "transparent",
    intermission: 0,
    currentAnimationId: void 0,
    visibilityPercentage: 0
  },
  j = /*#__PURE__*/function () {
    function j(t, e, i) {
      _classCallCheck(this, j);
      _defineProperty(this, "_lottie", void 0);
      _defineProperty(this, "_src", void 0);
      _defineProperty(this, "_animationConfig", void 0);
      _defineProperty(this, "_prevUserPlaybackOptions", {});
      _defineProperty(this, "_userPlaybackOptions", void 0);
      _defineProperty(this, "_hover", !1);
      _defineProperty(this, "_loop", !1);
      _defineProperty(this, "_counter", 0);
      _defineProperty(this, "_intermission", 0);
      _defineProperty(this, "_counterInterval", null);
      _defineProperty(this, "_container", null);
      _defineProperty(this, "_name", void 0);
      _defineProperty(this, "_mode", "normal");
      _defineProperty(this, "_background", "transparent");
      _defineProperty(this, "_animation", void 0);
      _defineProperty(this, "_defaultTheme", void 0);
      _defineProperty(this, "_activeAnimationId", void 0);
      _defineProperty(this, "_currentAnimationId", void 0);
      _defineProperty(this, "_testId", void 0);
      _defineProperty(this, "_listeners", new Map());
      _defineProperty(this, "_currentState", "initial");
      _defineProperty(this, "_stateBeforeFreeze", "initial");
      _defineProperty(this, "state", new a(Q));
      _defineProperty(this, "_light", !1);
      _defineProperty(this, "_worker", !1);
      _defineProperty(this, "_dotLottieLoader", new a$1());
      _defineProperty(this, "_activeStateId", void 0);
      _defineProperty(this, "_inInteractiveMode", !1);
      _defineProperty(this, "_scrollTicking", !1);
      _defineProperty(this, "_scrollCallback", void 0);
      _defineProperty(this, "_onShowIntersectionObserver", void 0);
      _defineProperty(this, "_visibilityPercentage", 0);
      _defineProperty(this, "_audios", []);
      _defineProperty(this, "_stateMachineManager", void 0);
      typeof t == "string" ? this._src = t : this._src = p(t), i != null && i.testId && (this._testId = i.testId), this._defaultTheme = (i == null ? void 0 : i.defaultTheme) || "", this._userPlaybackOptions = this._validatePlaybackOptions(i || {}), typeof (i == null ? void 0 : i.activeAnimationId) == "string" && (this._activeAnimationId = i.activeAnimationId), this._container = e || null, typeof (i == null ? void 0 : i.background) == "string" && this.setBackground(i.background), typeof (i == null ? void 0 : i.activeStateId) < "u" && (this._activeStateId = i.activeStateId);
      var _ref = i || {},
        n = _ref.rendererSettings,
        o = _objectWithoutProperties(_ref, _excluded);
      this._animationConfig = _objectSpread({
        loop: !1,
        autoplay: !1,
        renderer: "svg",
        rendererSettings: _objectSpread({
          clearCanvas: !0,
          progressiveLoad: !0,
          hideOnTransparent: !0,
          filterSize: {
            width: "200%",
            height: "200%",
            x: "-50%",
            y: "-50%"
          }
        }, n)
      }, o), i != null && i.light && (this._light = i.light), i != null && i.worker && (this._worker = i.worker), this._listenToHover(), this._listenToVisibilityChange();
    }
    return _createClass(j, [{
      key: "_listenToHover",
      value: function _listenToHover() {
        var _this = this;
        var i, n, o, a;
        var t = function t() {
            _this._hover && _this.currentState !== "playing" && _this.play();
          },
          e = function e() {
            _this._hover && _this.currentState === "playing" && _this.stop();
          };
        (i = this._container) == null || i.removeEventListener("mouseenter", t), (n = this._container) == null || n.removeEventListener("mouseleave", e), (o = this._container) == null || o.addEventListener("mouseleave", e), (a = this._container) == null || a.addEventListener("mouseenter", t);
      }
    }, {
      key: "_onVisibilityChange",
      value: function _onVisibilityChange() {
        !this._lottie || typeof document > "u" || (document.hidden && this.currentState === "playing" ? this.freeze() : this.currentState === "frozen" && this.unfreeze());
      }
    }, {
      key: "_listenToVisibilityChange",
      value: function _listenToVisibilityChange() {
        var _this2 = this;
        typeof document < "u" && typeof document.hidden < "u" && document.addEventListener("visibilitychange", function () {
          return _this2._onVisibilityChange();
        });
      }
    }, {
      key: "_getOption",
      value: function _getOption(t) {
        var _this3 = this;
        var i;
        if (typeof this._userPlaybackOptions[t] < "u") return this._userPlaybackOptions[t];
        var e = (i = this._dotLottieLoader.manifest) == null ? void 0 : i.animations.find(function (n) {
          return n.id === _this3._currentAnimationId;
        });
        return e && typeof e[t] < "u" ? e[t] : u[t];
      }
    }, {
      key: "_getPlaybackOptions",
      value: function _getPlaybackOptions() {
        var t = {};
        for (var e in u) typeof u[e] < "u" && (t[e] = this._getOption(e));
        return t;
      }
    }, {
      key: "_setPlayerState",
      value: function _setPlayerState(t) {
        var i, n, o;
        var e = t(this._getPlaybackOptions());
        try {
          a$2._parse(e);
        } catch (_unused) {
          j$1("Invalid PlaybackOptions, ".concat(JSON.stringify(e, null, 2)));
          return;
        }
        typeof e.defaultTheme < "u" && (this._defaultTheme = e.defaultTheme), typeof e.playMode < "u" && (this._mode = e.playMode), typeof e.intermission < "u" && (this._intermission = e.intermission), typeof e.hover < "u" && (this._hover = e.hover), typeof e.loop < "u" && (this.clearCountTimer(), this._loop = e.loop, this._counter = 0, (i = this._lottie) == null || i.setLoop(typeof e.loop == "number" ? !0 : e.loop)), typeof e.speed < "u" && ((n = this._lottie) == null || n.setSpeed(e.speed)), typeof e.autoplay < "u" && this._lottie && (this._lottie.autoplay = e.autoplay), typeof e.direction < "u" && ((o = this._lottie) == null || o.setDirection(e.direction));
      }
    }, {
      key: "_getOptionsFromAnimation",
      value: function _getOptionsFromAnimation(t) {
        var e = t.id,
          i = _objectWithoutProperties(t, _excluded2);
        return _objectSpread(_objectSpread({}, u), i);
      }
    }, {
      key: "_updateTestData",
      value: function _updateTestData() {
        !this._testId || !this._lottie || (window.dotLottiePlayer || (window.dotLottiePlayer = _defineProperty({}, this._testId, {})), window.dotLottiePlayer[this._testId] = {
          direction: this._lottie.playDirection,
          currentState: this._currentState,
          loop: this.loop,
          mode: this._mode,
          speed: this._lottie.playSpeed
        });
      }
    }, {
      key: "setContainer",
      value: function setContainer(t) {
        t !== this._container && (this._container = t, this.setBackground(this._background), this._listenToHover());
      }
    }, {
      key: "currentState",
      get: function get() {
        return this._currentState;
      }
    }, {
      key: "clearCountTimer",
      value: function clearCountTimer() {
        this._counterInterval && clearInterval(this._counterInterval);
      }
    }, {
      key: "setCurrentState",
      value: function setCurrentState(t) {
        this._currentState = t, this._notify(), this._updateTestData();
      }
    }, {
      key: "src",
      get: function get() {
        return this._src;
      }
    }, {
      key: "updateSrc",
      value: function updateSrc(t) {
        this._src !== t && (typeof t == "string" ? this._src = t : this._src = p(t), this._activeAnimationId = void 0, this._currentAnimationId = void 0, this.load());
      }
    }, {
      key: "intermission",
      get: function get() {
        return this._intermission;
      }
    }, {
      key: "hover",
      get: function get() {
        return this._hover;
      }
    }, {
      key: "setHover",
      value: function setHover(t) {
        typeof t == "boolean" && (this._hover = t, this._userPlaybackOptions.hover = t, this._notify());
      }
    }, {
      key: "setIntermission",
      value: function setIntermission(t) {
        this._intermission = t, this._userPlaybackOptions.intermission = t, this._notify();
      }
    }, {
      key: "mode",
      get: function get() {
        return this._mode;
      }
    }, {
      key: "animations",
      get: function get() {
        return this._dotLottieLoader.animationsMap;
      }
    }, {
      key: "themes",
      get: function get() {
        return this._dotLottieLoader.themeMap;
      }
    }, {
      key: "setMode",
      value: function setMode(t) {
        typeof t == "string" && (this._mode = t, this._userPlaybackOptions.playMode = t, this._setPlayerState(function () {
          return {
            playMode: t
          };
        }), this._notify(), this._updateTestData());
      }
    }, {
      key: "container",
      get: function get() {
        if (this._container) return this._container;
      }
    }, {
      key: "goToAndPlay",
      value: function goToAndPlay(t, e, i) {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("goToAndPlay() Can't use whilst loading.");
          return;
        }
        this._lottie.goToAndPlay(t, e, i), this.setCurrentState("playing");
      }
    }, {
      key: "goToAndStop",
      value: function goToAndStop(t, e, i) {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("goToAndStop() Can't use whilst loading.");
          return;
        }
        this._lottie.goToAndStop(t, e, i), this.setCurrentState("stopped");
      }
    }, {
      key: "seek",
      value: function seek(t) {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("seek() Can't use whilst loading.");
          return;
        }
        var e = t;
        typeof e == "number" && (e = Math.round(e));
        var i = /^([0-9]+)(%?)$/.exec(e.toString());
        if (!i) return;
        var n = i[2] === "%" ? this.totalFrames * Number(i[1]) / 100 : i[1];
        n !== void 0 && (this._lottie.goToAndPlay(n, !0), this.currentState === "playing" ? this.play() : this.currentState === "frozen" ? this.freeze() : this.pause());
      }
    }, {
      key: "_areNumbersInRange",
      value: function _areNumbersInRange(t, e) {
        return t >= 0 && t <= 1 && e >= 0 && e <= 1;
      }
    }, {
      key: "_updatePosition",
      value: function _updatePosition(t, e, i$1) {
        var _ref2 = t != null ? t : [0, this.totalFrames - 1],
          _ref3 = _slicedToArray(_ref2, 2),
          n = _ref3[0],
          o = _ref3[1],
          _ref4 = e != null ? e : [0, 1],
          _ref5 = _slicedToArray(_ref4, 2),
          a = _ref5[0],
          h = _ref5[1];
        if (!this._areNumbersInRange(a, h)) {
          i("threshold values must be between 0 and 1");
          return;
        }
        if (this.container) {
          var _this$container$getBo = this.container.getBoundingClientRect(),
            f = _this$container$getBo.height,
            _p = _this$container$getBo.top,
            d = window.innerHeight - _p,
            _m = window.innerHeight + f,
            _l = d / _m,
            _ = n + Math.round((_l - a) / (h - a) * (o - n));
          i$1 && i$1(_l), this.goToAndStop(_, !0), (_ >= o || _l >= h) && this._handleAnimationComplete();
        }
        this._scrollTicking = !1;
      }
    }, {
      key: "_requestTick",
      value: function _requestTick(t, e, i) {
        var _this4 = this;
        this._scrollTicking || (requestAnimationFrame(function () {
          return _this4._updatePosition(t, e, i);
        }), this._scrollTicking = !0);
      }
    }, {
      key: "playOnScroll",
      value: function playOnScroll(t) {
        var _this5 = this;
        this.stop(), this._scrollCallback && this.stopPlayOnScroll(), this._scrollCallback = function () {
          return _this5._requestTick(t == null ? void 0 : t.segments, t == null ? void 0 : t.threshold, t == null ? void 0 : t.positionCallback);
        }, window.addEventListener("scroll", this._scrollCallback);
      }
    }, {
      key: "stopPlayOnScroll",
      value: function stopPlayOnScroll() {
        this._scrollCallback && (window.removeEventListener("scroll", this._scrollCallback), this._scrollCallback = void 0);
      }
    }, {
      key: "stopPlayOnShow",
      value: function stopPlayOnShow() {
        this._onShowIntersectionObserver && (this._onShowIntersectionObserver.disconnect(), this._onShowIntersectionObserver = void 0);
      }
    }, {
      key: "addIntersectionObserver",
      value: function addIntersectionObserver(t) {
        var _this6 = this;
        if (!this.container) throw h("Can't play on show, player container element not available.");
        var e = {
            root: null,
            rootMargin: "0px",
            threshold: t != null && t.threshold ? t.threshold : [0, 1]
          },
          i = function i(n) {
            n.forEach(function (o) {
              var a, h;
              _this6._visibilityPercentage = o.intersectionRatio * 100, o.isIntersecting ? (t != null && t.callbackOnIntersect && t.callbackOnIntersect(_this6._visibilityPercentage), (a = _this6._container) == null || a.dispatchEvent(new Event("visibilityChange"))) : t != null && t.callbackOnIntersect && (t.callbackOnIntersect(0), (h = _this6._container) == null || h.dispatchEvent(new Event("visibilityChange")));
            });
          };
        this._onShowIntersectionObserver = new IntersectionObserver(i, e), this._onShowIntersectionObserver.observe(this.container);
      }
    }, {
      key: "playOnShow",
      value: function playOnShow(t) {
        var _this7 = this;
        var e;
        if (this.stop(), !this.container) throw h("Can't play on show, player container element not available.");
        this._onShowIntersectionObserver && this.stopPlayOnShow(), this.addIntersectionObserver({
          threshold: (e = t == null ? void 0 : t.threshold) != null ? e : [],
          callbackOnIntersect: function callbackOnIntersect(i) {
            i === 0 ? _this7.pause() : _this7.play();
          }
        });
      }
    }, {
      key: "_validatePlaybackOptions",
      value: function _validatePlaybackOptions(t) {
        if (!t) return {};
        var e = {};
        for (var _i = 0, _Object$entries = Object.entries(t); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            _i2 = _Object$entries$_i[0],
            _n = _Object$entries$_i[1];
          switch (_i2) {
            case "autoplay":
              typeof _n == "boolean" && (e.autoplay = _n);
              break;
            case "direction":
              typeof _n == "number" && [1, -1].includes(_n) && (e.direction = _n);
              break;
            case "loop":
              (typeof _n == "boolean" || typeof _n == "number") && (e.loop = _n);
              break;
            case "playMode":
              typeof _n == "string" && ["normal", "bounce"].includes(_n) && (e.playMode = _n);
              break;
            case "speed":
              typeof _n == "number" && (e.speed = _n);
              break;
            case "themeColor":
              typeof _n == "string" && (e.themeColor = _n);
              break;
            case "hover":
              typeof _n == "boolean" && (e.hover = _n);
              break;
            case "intermission":
              typeof _n == "number" && (e.intermission = _n);
              break;
            case "defaultTheme":
              typeof _n == "string" && (e.defaultTheme = _n);
              break;
          }
        }
        return this._requireValidPlaybackOptions(e), e;
      }
    }, {
      key: "_requireAnimationsInTheManifest",
      value: function _requireAnimationsInTheManifest() {
        var t;
        if (!((t = this._dotLottieLoader.manifest) != null && t.animations.length)) throw h("No animations found in manifest.");
      }
    }, {
      key: "_requireAnimationsToBeLoaded",
      value: function _requireAnimationsToBeLoaded() {
        if (this._dotLottieLoader.animationsMap.size === 0) throw h("No animations have been loaded.");
      }
    }, {
      key: "play",
      value: function () {
        var _play = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e) {
          var i, n, o, _o;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!["initial", "loading"].includes(this._currentState)) {
                  _context.next = 3;
                  break;
                }
                j$1("Player unable to play whilst loading.");
                return _context.abrupt("return");
              case 3:
                if (!(this._requireAnimationsInTheManifest(), this._requireAnimationsToBeLoaded(), this._lottie && !t)) {
                  _context.next = 6;
                  break;
                }
                this._lottie.playDirection === -1 && this._lottie.currentFrame === 0 ? this._lottie.goToAndPlay(this._lottie.totalFrames, !0) : this._lottie.play(), this.setCurrentState("playing");
                return _context.abrupt("return");
              case 6:
                if (!(typeof t == "number")) {
                  _context.next = 17;
                  break;
                }
                o = (i = this._dotLottieLoader.manifest) == null ? void 0 : i.animations[t];
                if (o) {
                  _context.next = 10;
                  break;
                }
                throw h("animation not found.");
              case 10:
                if (!(typeof e == "function")) {
                  _context.next = 15;
                  break;
                }
                _context.next = 13;
                return this.render(_objectSpread({
                  id: o.id
                }, e(this._getPlaybackOptions(), this._getOptionsFromAnimation(o))));
              case 13:
                _context.next = 17;
                break;
              case 15:
                _context.next = 17;
                return this.render({
                  id: o.id
                });
              case 17:
                if (!(typeof t == "string")) {
                  _context.next = 28;
                  break;
                }
                _o = (n = this._dotLottieLoader.manifest) == null ? void 0 : n.animations.find(function (a) {
                  return a.id === t;
                });
                if (_o) {
                  _context.next = 21;
                  break;
                }
                throw h("animation not found.");
              case 21:
                if (!(typeof e == "function")) {
                  _context.next = 26;
                  break;
                }
                _context.next = 24;
                return this.render(_objectSpread({
                  id: _o.id
                }, e(this._getPlaybackOptions(), this._getOptionsFromAnimation(_o))));
              case 24:
                _context.next = 28;
                break;
              case 26:
                _context.next = 28;
                return this.render({
                  id: _o.id
                });
              case 28:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function play(_x, _x2) {
          return _play.apply(this, arguments);
        }
        return play;
      }()
    }, {
      key: "playSegments",
      value: function playSegments(t, e) {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("playSegments() Can't use whilst loading.");
          return;
        }
        this._lottie.playSegments(t, e), this.setCurrentState("playing");
      }
    }, {
      key: "resetSegments",
      value: function resetSegments(t) {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("resetSegments() Can't use whilst loading.");
          return;
        }
        this._lottie.resetSegments(t);
      }
    }, {
      key: "togglePlay",
      value: function togglePlay() {
        this.currentState === "playing" ? this.pause() : this.play();
      }
    }, {
      key: "_getAnimationByIdOrIndex",
      value: function _getAnimationByIdOrIndex(t) {
        var e, i;
        if (this._requireAnimationsInTheManifest(), this._requireAnimationsToBeLoaded(), typeof t == "number") {
          var n = (e = this._dotLottieLoader.manifest) == null ? void 0 : e.animations[t];
          if (!n) throw h("animation not found.");
          return n;
        }
        if (typeof t == "string") {
          var _n2 = (i = this._dotLottieLoader.manifest) == null ? void 0 : i.animations.find(function (o) {
            return o.id === t;
          });
          if (!_n2) throw h("animation not found.");
          return _n2;
        }
        throw h("first param must be a number or string");
      }
    }, {
      key: "activeAnimationId",
      get: function get() {
        return this._getActiveAnimationId();
      }
    }, {
      key: "currentAnimationId",
      get: function get() {
        return this._currentAnimationId;
      }
    }, {
      key: "activeStateId",
      get: function get() {
        return this._activeStateId;
      }
    }, {
      key: "_startInteractivity",
      value: function () {
        var _startInteractivity2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (this._inInteractiveMode) {
                  _context2.next = 3;
                  break;
                }
                i("Can't start interactivity. Not in interactive mode. Call enterInteractiveMode(stateId: string) to start.");
                return _context2.abrupt("return");
              case 3:
                _context2.t0 = this._dotLottieLoader.stateMachinesMap.size === 0;
                if (!_context2.t0) {
                  _context2.next = 7;
                  break;
                }
                _context2.next = 7;
                return this._dotLottieLoader.getStateMachines();
              case 7:
                if (!(this._dotLottieLoader.stateMachinesMap.size === 0)) {
                  _context2.next = 9;
                  break;
                }
                throw h("No interactivity states are available.");
              case 9:
                if (!(t === "undefined")) {
                  _context2.next = 11;
                  break;
                }
                throw h("stateId is not specified.");
              case 11:
                _context2.t1 = this._stateMachineManager;
                if (_context2.t1) {
                  _context2.next = 16;
                  break;
                }
                _context2.next = 15;
                return a$3(Array.from(this._dotLottieLoader.stateMachinesMap.values()), this);
              case 15:
                this._stateMachineManager = _context2.sent;
              case 16:
                this._stateMachineManager.start(t);
              case 17:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function _startInteractivity(_x3) {
          return _startInteractivity2.apply(this, arguments);
        }
        return _startInteractivity;
      }()
    }, {
      key: "enterInteractiveMode",
      value: function enterInteractiveMode(t) {
        var e;
        if (t) this._inInteractiveMode || (this._prevUserPlaybackOptions = _objectSpread({}, this._userPlaybackOptions)), this._inInteractiveMode && ((e = this._stateMachineManager) == null || e.stop()), this._activeStateId = t, this._inInteractiveMode = !0, this._startInteractivity(t);else throw h("stateId must be a non-empty string.");
      }
    }, {
      key: "exitInteractiveMode",
      value: function exitInteractiveMode() {
        var t;
        this._inInteractiveMode && (this._inInteractiveMode = !1, this._activeStateId = "", (t = this._stateMachineManager) == null || t.stop(), this._userPlaybackOptions = {}, this._userPlaybackOptions = _objectSpread({}, this._prevUserPlaybackOptions), this._prevUserPlaybackOptions = {}, this.reset());
      }
    }, {
      key: "reset",
      value: function reset() {
        var i;
        var t = this._getActiveAnimationId(),
          e = (i = this._dotLottieLoader.manifest) == null ? void 0 : i.animations.find(function (n) {
            return n.id === t;
          });
        if (this._inInteractiveMode && this.exitInteractiveMode(), !e) throw h("animation not found.");
        this.play(t);
      }
    }, {
      key: "previous",
      value: function previous(t) {
        var _this8 = this;
        if (!this._dotLottieLoader.manifest || !this._dotLottieLoader.manifest.animations.length) throw h("manifest not found.");
        if (this._inInteractiveMode) {
          j$1("previous() is not supported in interactive mode.");
          return;
        }
        var e = this._dotLottieLoader.manifest.animations.findIndex(function (n) {
          return n.id === _this8._currentAnimationId;
        });
        if (e === -1) throw h("animation not found.");
        var i = this._dotLottieLoader.manifest.animations[(e - 1 + this._dotLottieLoader.manifest.animations.length) % this._dotLottieLoader.manifest.animations.length];
        if (!i || !i.id) throw h("animation not found.");
        typeof t == "function" ? this.render(_objectSpread({
          id: i.id
        }, t(this._getPlaybackOptions(), this._getOptionsFromAnimation(i)))) : this.render({
          id: i.id
        });
      }
    }, {
      key: "next",
      value: function next(t) {
        var _this9 = this;
        if (!this._dotLottieLoader.manifest || !this._dotLottieLoader.manifest.animations.length) throw h("manifest not found.");
        if (this._inInteractiveMode) {
          j$1("next() is not supported in interactive mode.");
          return;
        }
        var e = this._dotLottieLoader.manifest.animations.findIndex(function (n) {
          return n.id === _this9._currentAnimationId;
        });
        if (e === -1) throw h("animation not found.");
        var i = this._dotLottieLoader.manifest.animations[(e + 1) % this._dotLottieLoader.manifest.animations.length];
        if (!i || !i.id) throw h("animation not found.");
        typeof t == "function" ? this.render(_objectSpread({
          id: i.id
        }, t(this._getPlaybackOptions(), this._getOptionsFromAnimation(i)))) : this.render({
          id: i.id
        });
      }
    }, {
      key: "getManifest",
      value: function getManifest() {
        return this._dotLottieLoader.manifest;
      }
    }, {
      key: "resize",
      value: function resize() {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("resize() Can't use whilst loading.");
          return;
        }
        this._lottie.resize();
      }
    }, {
      key: "stop",
      value: function stop() {
        var _this10 = this;
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("stop() Can't use whilst loading.");
          return;
        }
        this.clearCountTimer(), this._counter = 0, this._setPlayerState(function () {
          return {
            direction: _this10._getOption("direction")
          };
        }), this._lottie.stop(), this.setCurrentState("stopped");
      }
    }, {
      key: "pause",
      value: function pause() {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("pause() Can't use whilst loading.");
          return;
        }
        this.clearCountTimer(), this._lottie.pause(), this.setCurrentState("paused");
      }
    }, {
      key: "freeze",
      value: function freeze() {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("freeze() Can't use whilst loading.");
          return;
        }
        this.currentState !== "frozen" && (this._stateBeforeFreeze = this.currentState), this._lottie.pause(), this.setCurrentState("frozen");
      }
    }, {
      key: "unfreeze",
      value: function unfreeze() {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("unfreeze() Can't use whilst loading.");
          return;
        }
        this._stateBeforeFreeze === "playing" ? this.play() : this.pause();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        var _this11 = this;
        var t, e;
        (t = this._container) != null && t.__lottie && (this._container.__lottie.destroy(), this._container.__lottie = null), this._audios.length && (this._audios.forEach(function (i) {
          i.unload();
        }), this._audios = []), this.clearCountTimer(), typeof document < "u" && document.removeEventListener("visibilitychange", function () {
          return _this11._onVisibilityChange();
        }), this._counter = 0, (e = this._lottie) == null || e.destroy(), this._lottie = void 0;
      }
    }, {
      key: "getAnimationInstance",
      value: function getAnimationInstance() {
        return this._lottie;
      }
    }, {
      key: "addEventListener",
      value: function addEventListener(t, e) {
        var i$1, n, o;
        this._listeners.has(t) || this._listeners.set(t, new Set()), (i$1 = this._listeners.get(t)) == null || i$1.add(e);
        try {
          t === "complete" ? (n = this._container) == null || n.addEventListener(t, e) : (o = this._lottie) == null || o.addEventListener(t, e);
        } catch (a) {
          i("addEventListener ".concat(a));
        }
      }
    }, {
      key: "getState",
      value: function getState() {
        var t, e, i, n, o, a, h;
        return {
          autoplay: (e = (t = this._lottie) == null ? void 0 : t.autoplay) != null ? e : !1,
          currentState: this._currentState,
          frame: this._frame,
          visibilityPercentage: this._visibilityPercentage,
          seeker: this._seeker,
          direction: (n = (i = this._lottie) == null ? void 0 : i.playDirection) != null ? n : 1,
          hover: this._hover,
          loop: this._loop || !1,
          playMode: this._mode,
          speed: (a = (o = this._lottie) == null ? void 0 : o.playSpeed) != null ? a : 1,
          background: this._background,
          intermission: this._intermission,
          defaultTheme: this._defaultTheme,
          currentAnimationId: this._currentAnimationId,
          activeStateId: (h = this._activeStateId) != null ? h : ""
        };
      }
    }, {
      key: "_notify",
      value: function _notify() {
        this.state.setState(this.getState());
      }
    }, {
      key: "totalFrames",
      get: function get() {
        var t;
        return ((t = this._lottie) == null ? void 0 : t.totalFrames) || 0;
      }
    }, {
      key: "direction",
      get: function get() {
        return this._lottie ? this._lottie.playDirection : 1;
      }
    }, {
      key: "setDirection",
      value: function setDirection(t) {
        this._requireValidDirection(t), this._setPlayerState(function () {
          return {
            direction: t
          };
        }), this._userPlaybackOptions.direction = t;
      }
    }, {
      key: "speed",
      get: function get() {
        var t;
        return ((t = this._lottie) == null ? void 0 : t.playSpeed) || 1;
      }
    }, {
      key: "setSpeed",
      value: function setSpeed(t) {
        this._requireValidSpeed(t), this._setPlayerState(function () {
          return {
            speed: t
          };
        }), this._userPlaybackOptions.speed = t;
      }
    }, {
      key: "autoplay",
      get: function get() {
        var t, e;
        return (e = (t = this._lottie) == null ? void 0 : t.autoplay) != null ? e : !1;
      }
    }, {
      key: "setAutoplay",
      value: function setAutoplay(t) {
        if (this._requireValidAutoplay(t), !this._lottie || ["loading"].includes(this._currentState)) {
          j$1("setAutoplay() Can't use whilst loading.");
          return;
        }
        this._setPlayerState(function () {
          return {
            autoplay: t
          };
        }), this._userPlaybackOptions.autoplay = t;
      }
    }, {
      key: "toggleAutoplay",
      value: function toggleAutoplay() {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("toggleAutoplay() Can't use whilst loading.");
          return;
        }
        this.setAutoplay(!this._lottie.autoplay);
      }
    }, {
      key: "defaultTheme",
      get: function get() {
        return this._defaultTheme;
      }
    }, {
      key: "setDefaultTheme",
      value: function setDefaultTheme(t) {
        this._setPlayerState(function () {
          return {
            defaultTheme: t
          };
        }), this._userPlaybackOptions.defaultTheme = t, this._animation && this.render();
      }
    }, {
      key: "loop",
      get: function get() {
        return this._loop;
      }
    }, {
      key: "setLoop",
      value: function setLoop(t) {
        this._requireValidLoop(t), this._setPlayerState(function () {
          return {
            loop: t
          };
        }), this._userPlaybackOptions.loop = t;
      }
    }, {
      key: "toggleLoop",
      value: function toggleLoop() {
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("toggleLoop() Can't use whilst loading.");
          return;
        }
        this.setLoop(!this._loop);
      }
    }, {
      key: "background",
      get: function get() {
        return this._background;
      }
    }, {
      key: "setBackground",
      value: function setBackground(t) {
        this._requireValidBackground(t), this._background = t, this._container && (this._container.style.backgroundColor = t);
      }
    }, {
      key: "_frame",
      get: function get() {
        return this._lottie ? this.currentState === "completed" ? this.direction === -1 ? 0 : this._lottie.totalFrames : this._lottie.currentFrame : 0;
      }
    }, {
      key: "_seeker",
      get: function get() {
        return this._lottie ? this._frame / this._lottie.totalFrames * 100 : 0;
      }
    }, {
      key: "revertToManifestValues",
      value: function () {
        var _revertToManifestValues = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
          var _this12 = this;
          var n, e, i, o, _a;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                !Array.isArray(t) || t.length === 0 ? e = ["autoplay", "defaultTheme", "direction", "hover", "intermission", "loop", "playMode", "speed", "activeAnimationId"] : e = t;
                i = !1;
                if (!e.includes("activeAnimationId")) {
                  _context3.next = 8;
                  break;
                }
                o = (n = this._dotLottieLoader.manifest) == null ? void 0 : n.activeAnimationId, _a = this._getAnimationByIdOrIndex(o || 0);
                this._activeAnimationId = o;
                _context3.next = 7;
                return this._setCurrentAnimation(_a.id);
              case 7:
                i = !0;
              case 8:
                e.forEach(function (o) {
                  switch (o) {
                    case "autoplay":
                      delete _this12._userPlaybackOptions.autoplay, _this12.setAutoplay(_this12._getOption("autoplay"));
                      break;
                    case "defaultTheme":
                      delete _this12._userPlaybackOptions.defaultTheme, _this12.setDefaultTheme(_this12._getOption("defaultTheme"));
                      break;
                    case "direction":
                      delete _this12._userPlaybackOptions.direction, _this12.setDirection(_this12._getOption("direction"));
                      break;
                    case "hover":
                      delete _this12._userPlaybackOptions.hover, _this12.setHover(_this12._getOption("hover"));
                      break;
                    case "intermission":
                      delete _this12._userPlaybackOptions.intermission, _this12.setIntermission(_this12._getOption("intermission"));
                      break;
                    case "loop":
                      delete _this12._userPlaybackOptions.loop, _this12.setLoop(_this12._getOption("loop"));
                      break;
                    case "playMode":
                      delete _this12._userPlaybackOptions.playMode, _this12.setMode(_this12._getOption("playMode")), _this12.setDirection(_this12._getOption("direction"));
                      break;
                    case "speed":
                      delete _this12._userPlaybackOptions.speed, _this12.setSpeed(_this12._getOption("speed"));
                      break;
                  }
                }), i && this.render();
              case 9:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function revertToManifestValues(_x4) {
          return _revertToManifestValues.apply(this, arguments);
        }
        return revertToManifestValues;
      }()
    }, {
      key: "removeEventListener",
      value: function removeEventListener(t, e) {
        var i$1, n, o;
        try {
          t === "complete" ? (i$1 = this._container) == null || i$1.removeEventListener(t, e) : (n = this._lottie) == null || n.removeEventListener(t, e), (o = this._listeners.get(t)) == null || o.delete(e);
        } catch (a) {
          i("removeEventListener", a);
        }
      }
    }, {
      key: "_handleAnimationComplete",
      value: function _handleAnimationComplete() {
        var e;
        typeof this._loop == "number" && this.stop();
        var t = this.direction === -1 ? 0 : this.totalFrames - 1;
        this.goToAndStop(t, !0), this._counter = 0, this.clearCountTimer(), this.setCurrentState("completed"), (e = this._container) == null || e.dispatchEvent(new Event("complete"));
      }
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this13 = this;
        var t;
        if (!this._lottie || ["loading"].includes(this._currentState)) {
          j$1("addEventListeners() Can't use whilst loading.");
          return;
        }
        this._lottie.addEventListener("enterFrame", function () {
          var i;
          if (!_this13._lottie) {
            j$1("enterFrame event : Lottie is undefined.");
            return;
          }
          Math.floor(_this13._lottie.currentFrame) === 0 && _this13.direction === -1 && ((i = _this13._container) == null || i.dispatchEvent(new Event("complete")), _this13.loop || _this13.setCurrentState("completed")), _this13._notify();
        }), this._lottie.addEventListener("loopComplete", function () {
          var n;
          if (!_this13._lottie) {
            j$1("loopComplete event : Lottie is undefined.");
            return;
          }
          (n = _this13._container) == null || n.dispatchEvent(new Event("loopComplete")), _this13.intermission > 0 && _this13.pause();
          var e = _this13._lottie.playDirection;
          if (typeof _this13._loop == "number" && _this13._loop > 0 && (_this13._counter += _this13._mode === "bounce" ? .5 : 1, _this13._counter >= _this13._loop)) {
            _this13._handleAnimationComplete();
            return;
          }
          _this13._mode === "bounce" && typeof e == "number" && (e = Number(e) * -1);
          var i = e === -1 ? _this13._lottie.totalFrames - 1 : 0;
          _this13.intermission ? (_this13.goToAndPlay(i, !0), _this13.pause(), _this13._counterInterval = window.setTimeout(function () {
            _this13._lottie && (_this13._setPlayerState(function () {
              return {
                direction: e
              };
            }), _this13.goToAndPlay(i, !0));
          }, _this13._intermission)) : (_this13._setPlayerState(function () {
            return {
              direction: e
            };
          }), _this13.goToAndPlay(e === -1 ? _this13.totalFrames - 1 : 0, !0));
        }), this._lottie.addEventListener("complete", function () {
          if (_this13._lottie && _this13._loop === !1 && _this13._mode === "bounce") {
            if (_this13._counter += .5, _this13._counter >= 1) {
              _this13._handleAnimationComplete();
              return;
            }
            _this13._counterInterval = window.setTimeout(function () {
              if (!_this13._lottie) return;
              var e = _this13._lottie.playDirection;
              _this13._mode === "bounce" && typeof e == "number" && (e = Number(e) * -1);
              var i = e === -1 ? _this13.totalFrames - 1 : 0;
              _this13._setPlayerState(function () {
                return {
                  direction: e
                };
              }), _this13.goToAndPlay(i, !0);
            }, _this13._intermission);
          } else _this13._handleAnimationComplete();
        });
        var _iterator = _createForOfIteratorHelper(this._listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              e = _step$value[0],
              _i3 = _step$value[1];
            if (e === "complete") {
              var _iterator2 = _createForOfIteratorHelper(_i3),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var n = _step2.value;
                  (t = this._container) == null || t.addEventListener(e, n);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else {
              var _iterator3 = _createForOfIteratorHelper(_i3),
                _step3;
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var _n3 = _step3.value;
                  this._lottie.addEventListener(e, _n3);
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "_setCurrentAnimation",
      value: function () {
        var _setCurrentAnimation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
          var e;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                this._currentState = "loading";
                _context4.next = 3;
                return this._dotLottieLoader.getAnimation(t);
              case 3:
                e = _context4.sent;
                this._currentAnimationId = t, this._animation = e, this._currentState = "ready";
              case 5:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function _setCurrentAnimation(_x5) {
          return _setCurrentAnimation2.apply(this, arguments);
        }
        return _setCurrentAnimation;
      }()
    }, {
      key: "_getAudioFactory",
      value: function () {
        var _getAudioFactory2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _this14 = this;
          var _yield$import, t;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this._animation && m(this._animation))) {
                  _context5.next = 6;
                  break;
                }
                _context5.next = 3;
                return import('./dotlottie-audio.js');
              case 3:
                _yield$import = _context5.sent;
                t = _yield$import.DotLottieAudio;
                return _context5.abrupt("return", function (i) {
                  var n = new t({
                    src: [i]
                  });
                  return _this14._audios.push(n), n;
                });
              case 6:
                return _context5.abrupt("return", null);
              case 7:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function _getAudioFactory() {
          return _getAudioFactory2.apply(this, arguments);
        }
        return _getAudioFactory;
      }()
    }, {
      key: "render",
      value: function () {
        var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t) {
          var _this15 = this;
          var b, g, v, P, S, L, k, w, I, O, C, M, T, A, D, E, F, x, e, i, n, o, a, h$1, f, p$1, d, _yield$Promise$all, _yield$Promise$all2, m, l, _;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (!(t != null && t.id)) {
                  _context6.next = 5;
                  break;
                }
                _context6.next = 3;
                return this._setCurrentAnimation(t.id);
              case 3:
                _context6.next = 7;
                break;
              case 5:
                if (this._animation) {
                  _context6.next = 7;
                  break;
                }
                throw h("no animation selected");
              case 7:
                e = (b = u.loop) != null ? b : !1, i = (g = u.autoplay) != null ? g : !1, n = (v = u.playMode) != null ? v : "normal", o = (P = u.intermission) != null ? P : 0, a = (S = u.hover) != null ? S : !1, h$1 = (L = u.direction) != null ? L : 1, f = (k = u.speed) != null ? k : 1, p$1 = (w = u.defaultTheme) != null ? w : "";
                e = (I = t == null ? void 0 : t.loop) != null ? I : this._getOption("loop"), i = (O = t == null ? void 0 : t.autoplay) != null ? O : this._getOption("autoplay"), n = (C = t == null ? void 0 : t.playMode) != null ? C : this._getOption("playMode"), o = (M = t == null ? void 0 : t.intermission) != null ? M : this._getOption("intermission"), a = (T = t == null ? void 0 : t.hover) != null ? T : this._getOption("hover"), h$1 = (A = t == null ? void 0 : t.direction) != null ? A : this._getOption("direction"), f = (D = t == null ? void 0 : t.speed) != null ? D : this._getOption("speed"), p$1 = (E = t == null ? void 0 : t.defaultTheme) != null ? E : this._getOption("defaultTheme");
                d = _objectSpread(_objectSpread({}, this._animationConfig), {}, {
                  autoplay: a ? !1 : i,
                  loop: typeof e == "number" ? !0 : e,
                  renderer: this._worker ? "svg" : (F = this._animationConfig.renderer) != null ? F : "svg"
                });
                _context6.next = 12;
                return Promise.all([this._dotLottieLoader.getTheme(p$1), this._getLottiePlayerInstance(), this._getAudioFactory()]);
              case 12:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                m = _yield$Promise$all2[0];
                l = _yield$Promise$all2[1];
                _ = _yield$Promise$all2[2];
                if (!(m && this._animation)) {
                  _context6.next = 21;
                  break;
                }
                this._animation = p(this._animation), this._animation.slots = m;
                _context6.next = 24;
                break;
              case 21:
                _context6.next = 23;
                return this._dotLottieLoader.getAnimation((x = this._currentAnimationId) != null ? x : "");
              case 23:
                this._animation = _context6.sent;
              case 24:
                if (!(this._activeStateId && !this._inInteractiveMode)) {
                  _context6.next = 27;
                  break;
                }
                this.enterInteractiveMode(this._activeStateId);
                return _context6.abrupt("return");
              case 27:
                this.destroy(), this._setPlayerState(function () {
                  return {
                    defaultTheme: p$1,
                    playMode: n,
                    intermission: o,
                    hover: a,
                    loop: e
                  };
                }), _ ? this._lottie = l.loadAnimation(_objectSpread(_objectSpread({}, d), {}, {
                  container: this._container,
                  animationData: this._animation,
                  audioFactory: _
                })) : this._lottie = l.loadAnimation(_objectSpread(_objectSpread({}, d), {}, {
                  container: this._container,
                  animationData: this._animation
                })), typeof this._lottie.resetSegments > "u" && (this._lottie.resetSegments = function () {
                  var V;
                  (V = _this15._lottie) == null || V.playSegments([0, _this15._lottie.totalFrames], !0);
                }), this.addEventListeners(), this._container && (this._container.__lottie = this._lottie), this._setPlayerState(function () {
                  return {
                    direction: h$1,
                    speed: f
                  };
                }), i && !a && (e === !1 && h$1 === -1 ? this.play() : this.setCurrentState("playing")), this._updateTestData();
              case 28:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function render(_x6) {
          return _render.apply(this, arguments);
        }
        return render;
      }()
    }, {
      key: "_getLottiePlayerInstance",
      value: function () {
        var _getLottiePlayerInstance2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          var i, t, e;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                t = (i = this._animationConfig.renderer) != null ? i : "svg";
                if (!this._worker) {
                  _context7.next = 7;
                  break;
                }
                t !== "svg" && j$1("Worker is only supported with svg renderer. Change or remove renderer prop to get rid of this warning.");
                _context7.next = 5;
                return import('./lottie_worker-Q23FJ6ZR.js');
              case 5:
                e = _context7.sent;
                return _context7.abrupt("return", e.default);
              case 7:
                _context7.t0 = t;
                _context7.next = _context7.t0 === "svg" ? 10 : _context7.t0 === "canvas" ? 20 : _context7.t0 === "html" ? 30 : 40;
                break;
              case 10:
                if (!this._light) {
                  _context7.next = 16;
                  break;
                }
                _context7.next = 13;
                return import('./lottie_light-KMJEUZFY.js');
              case 13:
                e = _context7.sent;
                _context7.next = 19;
                break;
              case 16:
                _context7.next = 18;
                return import('./lottie_svg-MJGYILXD.js');
              case 18:
                e = _context7.sent;
              case 19:
                return _context7.abrupt("break", 41);
              case 20:
                if (!this._light) {
                  _context7.next = 26;
                  break;
                }
                _context7.next = 23;
                return import('./lottie_light_canvas-B5UTTNXA.js');
              case 23:
                e = _context7.sent;
                _context7.next = 29;
                break;
              case 26:
                _context7.next = 28;
                return import('./lottie_canvas-CDSUBMCL.js');
              case 28:
                e = _context7.sent;
              case 29:
                return _context7.abrupt("break", 41);
              case 30:
                if (!this._light) {
                  _context7.next = 36;
                  break;
                }
                _context7.next = 33;
                return import('./lottie_light_html-SLCECTRT.js');
              case 33:
                e = _context7.sent;
                _context7.next = 39;
                break;
              case 36:
                _context7.next = 38;
                return import('./lottie_html-X3TYKVQI.js');
              case 38:
                e = _context7.sent;
              case 39:
                return _context7.abrupt("break", 41);
              case 40:
                throw new Error("Invalid renderer: ".concat(t));
              case 41:
                return _context7.abrupt("return", e.default);
              case 42:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function _getLottiePlayerInstance() {
          return _getLottiePlayerInstance2.apply(this, arguments);
        }
        return _getLottiePlayerInstance;
      }()
    }, {
      key: "_getActiveAnimationId",
      value: function _getActiveAnimationId() {
        var e, i, n, o;
        var t = this._dotLottieLoader.manifest;
        return (o = (n = (e = this._activeAnimationId) != null ? e : t == null ? void 0 : t.activeAnimationId) != null ? n : (i = t == null ? void 0 : t.animations[0]) == null ? void 0 : i.id) != null ? o : void 0;
      }
    }, {
      key: "load",
      value: function () {
        var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t) {
          var _i4, _i5, e;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this._currentState === "loading")) {
                  _context8.next = 3;
                  break;
                }
                j$1("Loading in progress..");
                return _context8.abrupt("return");
              case 3:
                _context8.prev = 3;
                if (!(this.setCurrentState("loading"), typeof this._src == "string")) {
                  _context8.next = 15;
                  break;
                }
                if (!n(this._src)) {
                  _context8.next = 10;
                  break;
                }
                _i4 = JSON.parse(this._src);
                this._dotLottieLoader.loadFromLottieJSON(_i4);
                _context8.next = 13;
                break;
              case 10:
                _i5 = new URL(this._src, window.location.href);
                _context8.next = 13;
                return this._dotLottieLoader.loadFromUrl(_i5.toString());
              case 13:
                _context8.next = 20;
                break;
              case 15:
                if (!(typeof this._src == "object" && l(this._src))) {
                  _context8.next = 19;
                  break;
                }
                this._dotLottieLoader.loadFromLottieJSON(this._src);
                _context8.next = 20;
                break;
              case 19:
                throw h("Invalid src provided");
              case 20:
                if (this._dotLottieLoader.manifest) {
                  _context8.next = 22;
                  break;
                }
                throw h("No manifest found");
              case 22:
                e = this._getActiveAnimationId();
                if (e) {
                  _context8.next = 25;
                  break;
                }
                throw h("No active animation found");
              case 25:
                _context8.next = 27;
                return this._setCurrentAnimation(e);
              case 27:
                _context8.next = 29;
                return this.render(t);
              case 29:
                _context8.next = 34;
                break;
              case 31:
                _context8.prev = 31;
                _context8.t0 = _context8["catch"](3);
                this.setCurrentState("error"), _context8.t0 instanceof Error && i("Error loading animation: ".concat(_context8.t0.message));
              case 34:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this, [[3, 31]]);
        }));
        function load(_x7) {
          return _load.apply(this, arguments);
        }
        return load;
      }()
    }, {
      key: "setErrorState",
      value: function setErrorState(t) {
        this.setCurrentState("error"), i(t);
      }
    }, {
      key: "_requireValidDirection",
      value: function _requireValidDirection(t) {
        if (t !== -1 && t !== 1) throw h("Direction can only be -1 (backwards) or 1 (forwards)");
      }
    }, {
      key: "_requireValidIntermission",
      value: function _requireValidIntermission(t) {
        if (t < 0 || !Number.isInteger(t)) throw h("intermission must be a positive number");
      }
    }, {
      key: "_requireValidLoop",
      value: function _requireValidLoop(t) {
        if (typeof t == "number" && (!Number.isInteger(t) || t < 0)) throw h("loop must be a positive number or boolean");
      }
    }, {
      key: "_requireValidSpeed",
      value: function _requireValidSpeed(t) {
        if (typeof t != "number") throw h("speed must be a number");
      }
    }, {
      key: "_requireValidBackground",
      value: function _requireValidBackground(t) {
        if (typeof t != "string") throw h("background must be a string");
      }
    }, {
      key: "_requireValidAutoplay",
      value: function _requireValidAutoplay(t) {
        if (typeof t != "boolean") throw h("autoplay must be a boolean");
      }
    }, {
      key: "_requireValidPlaybackOptions",
      value: function _requireValidPlaybackOptions(t) {
        t.direction && this._requireValidDirection(t.direction), t.intermission && this._requireValidIntermission(t.intermission), t.loop && this._requireValidLoop(t.loop), t.speed && this._requireValidSpeed(t.speed);
      }
    }], [{
      key: "isPathJSON",
      value: function isPathJSON(t) {
        var e;
        return ((e = t.split(".").pop()) == null ? void 0 : e.toLowerCase()) === "json";
      }
    }, {
      key: "getLottieWebVersion",
      value: function getLottieWebVersion() {
        return "".concat(U.dependencies["lottie-web"]);
      }
    }]);
  }();
export { W as a, K as b, G as c, u as d, Q as e, j as f };